import React, { useEffect, useState } from 'react';
import {
  Box,
  makeStyles,
  Paper,
  Typography,
  Grid,
  Divider,
  ButtonBase,
  Button,
  IconButton,
} from '@material-ui/core';
import { AiOutlinePlus } from 'react-icons/ai';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import KenInputField from '../../../../../../../global_components/KenInputField';

import KenSelectWrap from '../../../../../../../global_components/KenSelect';
import {
  getDownGradingRulesSetup,
  postDownGradingRulesSetup,
  deleteDowngradingRule,
  getMasterComponent,
  deleteMasterComponent,
  deleteMasterComponentData,
  postMasterComponent,
} from '../../../../../../../Utils/apiServices';

const useStyles = makeStyles((theme) => ({
  box1: {
    // maxWidth: 832,
    // minWidth: 400,
    position: 'relative',
  },
  healthGrid: {
    marginTop: theme.spacing(2),
  },
  grid: {
    minWidth: '13.8vw',
  },
  detailTitle1: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
    textTransform: 'uppercase',
  },
  back: {
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
    marginLeft: '-8px',
  },
  iconBack: {
    height: 12,
  },
  loader: {
    minHeight: '100vh',
    minWidth: '100vh',
  },
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  boxContainer: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
    paddingTop: '62px',
    paddingBottom: '30px',
  },
  boxContainer1: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
  },
  imageSection: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
  },
  innerTitle: {
    fontSize: 16,
    marginTop: '30px',
  },
  subHeaderTitle: {
    width: '100%',
  },
  ButtonStyle: {
    marginTop: '10px',
  },
}));
const selectOptionsMasterComponent = [
  {
    label: 'CLASS PARTICIPATION',
    value: 'CLASS PARTICIPATION',
  },
  {
    label:
      'CASE STUDIES AND ROLE PLAYS IN EITHER AUTHENTIC OR SIMULATED ENVIRONMENTS',
    value:
      'CASE STUDIES AND ROLE PLAYS IN EITHER AUTHENTIC OR SIMULATED ENVIRONMENTS',
  },
  {
    label: 'INDIVIDUAL AND GROUP ASSIGNMENTS',
    value: 'INDIVIDUAL AND GROUP ASSIGNMENTS',
  },
  {
    label: 'FIELD WORK',
    value: 'FIELD WORK',
  },
  {
    label: 'STUDENT BOARD ROOM DISCUSSIONS AND SUBMISSION',
    value: 'STUDENT BOARD ROOM DISCUSSIONS AND SUBMISSION',
  },
  {
    label: 'QUIZZES',
    value: 'QUIZZES',
  },
  {
    label: 'ESSAYS AND DISCUSSION PAPERS',
    value: 'ESSAYS AND DISCUSSION PAPERS',
  },
  {
    label: 'VERBAL AND WRITTEN PRESENTATIONS',
    value: 'VERBAL AND WRITTEN PRESENTATIONS',
  },
  {
    label: 'CAPSTONE AND RESEARCH PROJECTS',
    value: 'CAPSTONE AND RESEARCH PROJECTS',
  },
  {
    label: 'INTEGRATED LEARNING',
    value: 'INTEGRATED LEARNING',
  },
  {
    label: 'MID- TERM',
    value: 'MID- TERM',
  },
  {
    label: 'FINAL EXAMINATIONS',
    value: 'FINAL EXAMINATIONS',
  },
];
const selectOptionsNumberOfSubCom = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
  {
    label: '6',
    value: 6,
  },
  {
    label: '7',
    value: 7,
  },
  {
    label: '8',
    value: 8,
  },
];

const EvaluationSubcomponents = ({}) => {
  // const MasterComponent :[]
  // const [data, setData] = useState(state);
  const classes = useStyles();
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };

  const [listOfComponent, setListOfComponent] = React.useState([
    {
      id: 1,
      MasterComponent: 'Quiz',
      NumberOfSubCom: 1,
      weightage: '20',
      isEditing: false,
      subComp: [
        {
          id: 1,
          subComponent: 'Quiz',
          subweightage: '20',
          isEditing: false,
        },
      ],
    },
  ]);

  const [listOfSubComponent, setListOfsubComponent] = React.useState([]);

  const [relationshipAcc, setRelationshipAcc] = useState();
  const [deleteRow, setDeleteRow] = useState(false);

  const handleChangeRelation = (evt, i) => {
    console.log('evt.name', evt);
    setListOfComponent(
      listOfComponent.map((e, index) => {
        console.log('eeeeee', e);
        if (i == index) {
          return {
            ...e,
            [evt.target.name]: evt.target.value,
          };
        } else {
          return { ...e, e };
        }
      })
    );
  };

  const handleChangeRelationSubComponent = (evt, relId, id) => {
    console.log('evt.name', id);
    setListOfComponent(
      listOfComponent.map((e, index) => {
        if (e.id == relId) {
          return {
            ...e,
            subComp: e.subComp.map((eve, i) => {
              console.log('eve.id eve.id eve.id ', eve.id, i);
              if (eve.id == id) {
                return {
                  ...eve,
                  [evt.target.name]: evt.target.value,
                };
              } else {
                return eve;
              }
            }),
          };
        } else {
          return { ...e, e };
        }
      })
    );
  };

  const addRow = () => {
    setListOfComponent((prevState) => {
      return [
        ...prevState,
        {
          // id: idGenerater(),
          MasterComponent: '',
          NumberOfSubCom: '',
          weightage: '',
          subComp: [],
          isEditing: true,
          isNew: true,
        },
      ];
    });
  };

  let selectedMasterComponents = [];
  listOfComponent.map((map) => {
    return selectedMasterComponents.push(map.MasterComponent);
  });

  // let selectOptionsMasterComponentsssss = [];

  const filterMaster = selectOptionsMasterComponent.filter((val) => {
    return (
      !selectedMasterComponents.includes(val.label) &&
      !selectedMasterComponents.includes(val.value)
    );
  });

  const selectOptionsMasterComponentsssss = filterMaster?.map((e) => {
    return {
      label: e.label,
      value: e.label,
    };
  });

  const deleteRowHandle = (i) => {
    deleteDowngradingRule(i)
      .then((res) => {
        // DefaultGrade();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const onEdit = (id) => {
    setListOfComponent((prev) => {
      return prev.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            isEditing: true,
          };
        } else {
          return item;
        }
      });
    });
  };

  const onEdit1 = (id) => {
    setListOfComponent((prev) => {
      return prev.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            isEditing: true,
          };
        } else {
          return item;
        }
      });
    });
  };

  const onEditSubComponet = (mainId, id) => {
    setListOfComponent((prev) => {
      return prev.map((item) => {
        if (item.id == mainId) {
          return {
            ...item,
            subComp: item?.subComp?.map((data) => {
              // console.log('datadatadatadatadatadatadata', item, mainId, id);

              if (data.id == id) {
                return {
                  ...data,
                  isEditing: true,
                };
              } else {
                return data;
              }
            }),
          };
        } else {
          return item;
        }
      });
    });
  };

  const onSave = (id, subId, masterData) => {
    setListOfComponent((prev) => {
      return prev.map((item, index) => {
        if (item.id == id && !item.isNew) {
          if (masterData === 'subData' || masterData === 'MasterData') {
            return {
              id: item.id,
              MasterComponent: item.MasterComponent,
              NumberOfSubCom: item.NumberOfSubCom,
              weightage: item.weightage,
              subComp: item.subComp.map((data) => {
                if (data.id === subId) {
                  return {
                    id: data.id,
                    subComponent: data.subComponent,
                    subweightage: data.subweightage,
                    isEditing: false,
                  };
                } else {
                  return data;
                }
              }),
            };
          }

          // return ab;
        }
        if (item.isNew === true) {
          const updatedList = [];
          for (let index = 0; index < item.NumberOfSubCom; index++) {
            let i = index + 1;

            updatedList.push({
              // id: idGenerater(),
              subComponent: 'Sub Component' + '    ' + i,
              subweightage: 0,
              isEditing: false,
            });
          }

          return {
            id: item.id,
            MasterComponent: item.MasterComponent,
            NumberOfSubCom: item.NumberOfSubCom,
            weightage: item.weightage,
            subComp: updatedList,
          };
        } else {
          return item;
        }
      });
    });
  };

  const postData = () => {
    const PanaltyData = listOfComponent.map((prev) => {
      console.log('prevprevprevprev', prev);
      return {
        componentId: prev.id,
        componentName: prev.MasterComponent,
        numberofSubcomps: prev.NumberOfSubCom,
        weightagePercent: prev.weightagePercent,
        subComponents: prev.subComp.map((data) => {
          return {
            subComponentid: data.id,
            subComponentName: data.subComponent,
            subcompWeightageCompPercent: data.subweightage,
          };
        }),
      };
    });

    postMasterComponent(PanaltyData)
      .then((res) => {
        DefaultGrade();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const DefaultGrade = () => {
    getMasterComponent().then((res) => {
      const ab = res.map((item) => {
        return {
          id: item.componentId,
          MasterComponent: item.componentName,
          NumberOfSubCom: item.numberofSubcomps,
          weightage: item.weightagePercent,
          subComp: item?.subComponents.map((res) => {
            return {
              id: res.subComponentid,
              subComponent: res.subComponentName,
              subweightage: res.subcompWeightageCompPercent,
            };
          }),
        };
      });

      setListOfComponent(ab);
    });
  };
  const deleteData = (id) => {
    deleteMasterComponentData(id)
      .then((res) => {
        DefaultGrade();
        console.log('res', res);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const deleteSubComponentData = (id) => {
    deleteMasterComponentData(id)
      .then((res) => {
        DefaultGrade();
        console.log('res', res);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  useEffect(() => {
    DefaultGrade();
  }, []);

  return (
    <div component={Paper} className="aaaaaaaa">
      <Box>
        <Grid item xs={12} sm={12}>
          <Grid
            style={{ backgroundColor: '#ebebeb' }}
            component={Paper}
            container
            spacing={2}
          >
            <Grid item xs={12} sm={12} />
            <>
              {' '}
              <Grid item xs={2} sm={4}>
                <Typography>
                  <b>Master Component</b>
                </Typography>
              </Grid>{' '}
              <Grid item xs={2} sm={3}>
                <Typography>
                  <b>Weightage In Percentage</b>
                </Typography>
              </Grid>{' '}
              <Grid item xs={2} sm={3}>
                <Typography>
                  <b>Number Of Sub Component</b>
                </Typography>
              </Grid>
              <Grid item xs={1} sm={1}>
                <Typography>
                  <b>Edit</b>
                </Typography>
              </Grid>
              <Grid item xs={1} sm={1}>
                <Typography>
                  <b>Delete</b>
                </Typography>
              </Grid>
              <Divider></Divider>
            </>
          </Grid>
          {/* <Divider></Divider> */}
          <div>
            {' '}
            {listOfComponent?.map((relData, index) => {
              console.log('relDatarelDatarelDatarelData', relData);
              return (
                <>
                  {' '}
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} />
                    <Grid item xs={2} sm={4}>
                      {relData.isEditing ? (
                        <KenSelectWrap
                          // disabled={readOnly}
                          // label="Downgrading Level"
                          name="MasterComponent"
                          options={selectOptionsMasterComponent}
                          value={relData.MasterComponent}
                          dropdownColor="#FFFFFF"
                          onChange={(e) => handleChangeRelation(e, index)}
                          // styles={CustomStyle}
                          required
                        />
                      ) : (
                        <>{relData.MasterComponent}</>
                      )}
                    </Grid>
                    <Grid item xs={2} sm={3}>
                      {relData.isEditing ? (
                        <KenInputField
                          optionalLabel={false}
                          name="weightage"
                          value={relData.weightage}
                          dropdownColor="#FFFFFF"
                          onChange={(e) => handleChangeRelation(e, index)}
                        />
                      ) : (
                        <>{relData.weightage}</>
                      )}
                    </Grid>
                    <Grid item xs={2} sm={3}>
                      {relData.isEditing ? (
                        <KenSelectWrap
                          // disabled={readOnly}
                          // label="Downgrading Level"
                          name="NumberOfSubCom"
                          options={selectOptionsNumberOfSubCom}
                          value={relData.NumberOfSubCom}
                          dropdownColor="#FFFFFF"
                          onChange={(e) => handleChangeRelation(e, index)}
                          // styles={CustomStyle}
                          required
                        />
                      ) : (
                        <>{relData.NumberOfSubCom}</>
                      )}
                    </Grid>
                    <Grid item xs={1} sm={1}>
                      {relData.isEditing ? (
                        <IconButton
                          variant="contained"
                          color="error"
                          // startIcon={<DeleteForeverIcon />}
                          onClick={(e) =>
                            onSave(relData.id, 'NULL', 'MasterData')
                          }
                        >
                          <DoneAllIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          variant="contained"
                          color="error"
                          // startIcon={<DeleteForeverIcon />}
                          onClick={(e) => onEdit(relData.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </Grid>
                    <Grid item xs={1} sm={1}>
                      <IconButton
                        variant="contained"
                        color="error"
                        // startIcon={<DeleteForeverIcon />}
                        onClick={() => deleteMasterComponent(relData.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <div style={{ paddingLeft: '10px', background: 'aliceblue' }}>
                    {console.log(
                      'relData?.subComp.lengthrelData?.subComp.lengthrelData?.subComp.length',
                      relData?.subComp.length
                    )}
                    {relData?.subComp.length > 0 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} />
                        <>
                          <Divider></Divider>
                          <Grid item xs={2} sm={1}></Grid>{' '}
                          <Grid item xs={2} sm={4}>
                            <Typography>
                              <b>Sub Component</b>
                            </Typography>
                          </Grid>{' '}
                          <Grid item xs={2} sm={3}>
                            <Typography>
                              <b>Weightage In Percentage</b>
                            </Typography>
                          </Grid>{' '}
                          <Grid item xs={1} sm={1}>
                            <Typography>
                              <b>Edit</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={1} sm={1}>
                            <Typography>
                              <b>Delete</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={2} sm={2}>
                            <Typography></Typography>
                          </Grid>{' '}
                        </>
                      </Grid>
                    )}
                    <Divider></Divider>
                    {relData?.subComp?.map((item, i) => {
                      return (
                        <>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} />
                            <Grid item xs={2} sm={1}></Grid>{' '}
                            <Grid item xs={2} sm={4}>
                              {item.isEditing ? (
                                <KenInputField
                                  // disabled={readOnly}
                                  name="subComponent"
                                  value={item.subComponent}
                                  optionalLabel={false}
                                  dropdownColor="#FFFFFF"
                                  onChange={(e) =>
                                    handleChangeRelationSubComponent(
                                      e,
                                      relData.id,
                                      item.id
                                    )
                                  }
                                />
                              ) : (
                                <>{item.subComponent}</>
                              )}
                            </Grid>
                            <Grid item xs={2} sm={3}>
                              {item.isEditing ? (
                                <KenInputField
                                  name="subweightage"
                                  value={item.subweightage}
                                  optionalLabel={false}
                                  dropdownColor="#FFFFFF"
                                  onChange={(e) =>
                                    handleChangeRelationSubComponent(
                                      e,
                                      relData.id,
                                      item.id
                                    )
                                  }
                                />
                              ) : (
                                <>{item.subweightage}</>
                              )}
                            </Grid>
                            <Grid item xs={1} sm={1}>
                              {item.isEditing ? (
                                <IconButton
                                  variant="contained"
                                  color="error"
                                  // startIcon={<DeleteForeverIcon />}
                                  onClick={(e) =>
                                    onSave(relData.id, item.id, 'subData')
                                  }
                                >
                                  <DoneAllIcon />
                                </IconButton>
                              ) : (
                                <IconButton
                                  variant="contained"
                                  color="error"
                                  // startIcon={<DeleteForeverIcon />}
                                  onClick={(e) =>
                                    onEditSubComponet(relData.id, item.id)
                                  }
                                >
                                  <EditIcon />
                                </IconButton>
                              )}
                            </Grid>
                            <Grid item xs={1} sm={1}>
                              {/* <KenInputField
                          label="Name"
                          name="name"
                          value={item.res.name}
                          dropdownColor="#FFFFFF"
                          onChange={(e) => handleChangeRelation(e, index)}
                        /> */}

                              <IconButton
                                variant="contained"
                                color="error"
                                // startIcon={<DeleteForeverIcon />}
                                onClick={() => deleteData(item.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                            <Grid item xs={2} sm={2}></Grid>{' '}
                            {/* <Grid item xs={12} sm={4}>
                        <KenInputField
                          label="Reduce By"
                          name="link"
                          value={relData.link}
                          dropdownColor="#FFFFFF"
                          onChange={(e) => handleChangeRelation(e, index)}
                          optionalLabel={false}
                        />
                      </Grid> */}
                          </Grid>
                        </>
                      );
                    })}
                  </div>
                  {/* {listOfSubComponent.map((item, i) => {
                  if (i === 5) {
                    return <div>dssdssd</div>;
                  } else {
                    return;
                  }
                })} */}
                  <Divider></Divider>
                  <Divider></Divider>
                </>
              );
            })}
          </div>

          <Grid item xs={12} sm={3} style={{ marginTop: 23 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => addRow(e)}
            >
              + Add Row
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => postData(e)}
              style={{ marginLeft: '15px' }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default EvaluationSubcomponents;
